import { Component, Input, OnInit } from '@angular/core';
import { AppService } from '../../../../../../../../app.service';
import { DialogButton, DialogData, DialogService } from '../../../../../../../../core/services/dialog.service';
import { ExtendedClaim2User, UserData } from '../../../../../../interfaces/user-data';
import {Claim2UserI, ClaimI} from '../../../../../../interfaces/claim.interface';

@Component({
  selector: 'app-claim2user',
  templateUrl: './claim2user.component.html',
  styleUrls: ['./claim2user.component.scss']
})
export class Claim2userComponent implements OnInit {

  @Input() userData: UserData;
  @Input() claims2user: Claim2UserI[];

  constructor(public app: AppService, public dialog: DialogService) {
  }

  ngOnInit(): void {
  }


  getClaim2user(name: string): Claim2UserI {
    if (this.claims2user) {
      return this.claims2user.find(c => c.claim_name === name);
    } else {
      return null;
    }
  }

  deleteClaim2User(c: ExtendedClaim2User, scopeI: number, claimI: number) {
    const y: DialogButton = {
      name: 'Ja',
      color: 'warn',
      handler: () => {
        console.log('confirm');
        dialRef.close();
        this.app.claim2userDelete(c.id).then(res => {
          if(res) {
            this.userData.scopedClaims2user[scopeI].claims.splice(claimI, 1);
            this.app.toast.open('Der Zugang wurde gelöscht');
          }
        }).catch(err => {
          this.app.toast.open('Unbekannter Fehler', null, {
            panelClass: 'warn'
          });
        });
      }
    };

    const n: DialogButton = {
      name: 'Abbrechen',
      handler: () => {
        dialRef.close();
      }
    };

    const data: DialogData = {
      subTitle: 'Wollen Sie den Zugang löschen?',
      buttons: [y, n]
    };

    const dialRef = this.dialog.alert(data, {width: '50vh'});
  }

  sendInvitation(c: ClaimI) {
    const c2u = this.getClaim2user(c.name);
    const params = {
      userId: c2u.user_id,
      c2cId: c2u.c2c_id,
    };
    this.app.newInvitation(params).then(res => {
      /**
       * todo toaster
       */
      console.log(res);
    });
  }

  privateClaim(c: ExtendedClaim2User) {
    return c.external_customer_id.includes('@');
  }

}
